import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { defaultButtonClasses, secondaryButtonClasses } from "@/constants/ui";
import { useCancelBookingDialog } from "../useCancelBookingDialog";
import { describeBookingRecurrence } from "../recurrenceSummary";

export const WarnScreen = () => {
  const { booking, isRecurring, willBeCharged, navigateTo, onClose } = useCancelBookingDialog();
  return (
    <div data-testid="cancel-dialog-warn" className="w-full flex flex-col gap-4 bg-white rounded-xl my-4 p-6">
      <h2 className="text-2xl font-semibold">Cancel this booking?</h2>
      <div className="text-sm text-gray-600">
        <p className="font-mono uppercase">{(booking.shortCode ?? "").toUpperCase()}</p>
        {/* Recurring bookings show their cadence rather than a single (misleading) genesis date. */}
        {isRecurring
          ? <p data-testid="cancel-recurrence-summary">{describeBookingRecurrence(booking)}</p>
          : <p>{new Date(booking.date).toDateString()} · {booking.startTime}–{booking.endTime}</p>}
      </div>
      {willBeCharged && (
        <div data-testid="cancel-charge-warning" className="p-3 bg-amber-50 border-2 border-amber-400 rounded-lg flex gap-2">
          <AlertTriangle className="size-5 text-amber-600 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="font-semibold text-amber-900 text-sm mb-1">Cancellation charges apply</h3>
            <p className="text-xs text-amber-800">This booking is within 24 hours of its start time, so the cancellation is chargeable.</p>
          </div>
        </div>
      )}
      <div className="flex flex-col gap-2 mt-2">
        <Button data-testid="cancel-continue" className={`w-full ${defaultButtonClasses}`} onClick={() => navigateTo(isRecurring ? "from-date" : "confirm")}>Continue</Button>
        <Button data-testid="cancel-keep" variant="outline" className={`w-full ${secondaryButtonClasses}`} onClick={onClose}>Keep booking</Button>
      </div>
    </div>
  );
};
